import classNames from 'classnames';
import React, { FC, useMemo } from 'react';
import { useTitle } from '../../utils/client_hooks';

interface CommonTitleProps {
  title?: any;
  noPadding?: boolean;
  noMargin?: boolean;
  level?: 1 | 2 | 3 | 4 | 5;
  className?: string;
  children?: React.ReactNode;
}

const CommonTitle: FC<React.PropsWithChildren<CommonTitleProps>> = ({
  title,
  level = 3,
  noPadding = false,
  noMargin = false,
  children,
  className = '',
}) => {
  const theTitle = useTitle(title || '');

  const classes = useMemo(
    () =>
      classNames('commonTitle  ic1-text-heading ', className, {
        noPadding,
        noMargin,
      }),
    [theTitle, noPadding, noMargin, className],
  );

  switch (level) {
    case 1:
      return (
        <h1 className={classes + ' ic1-text-heading-1'}>
          {theTitle} {children}
        </h1>
      );

    case 2:
      return (
        <h2 className={classes + ' ic1-text-heading-2'}>
          {theTitle} {children}
        </h2>
      );

    case 3:
      return (
        <h3 className={classes + ' ic1-text-heading-3'}>
          {theTitle} {children}
        </h3>
      );

    case 4:
      return (
        <h4 className={classes + ' ic1-text-heading-4'}>
          {theTitle} {children}
        </h4>
      );

    case 5:
      return (
        <h5 className={classes + ' ic1-text-heading-5'}>
          {theTitle} {children}
        </h5>
      );

    default:
      return (
        <h2 className={classes + ' ic1-text-heading-2'}>
          {theTitle} {children}
        </h2>
      );
  }
};

export default CommonTitle;
